import ScrollToTop from "components/routes/ScrollToTop";
import { Routes } from "components/routes/Routes";
import "./App.scss";
import { useTranslationScript } from "hooks/useTranslationScript";

function App() {
  useTranslationScript();
  return (
    <div className="App">
      <ScrollToTop />
      <Routes />
    </div>
  );
}
export default App;
